import type { drawingPage } from 'reduxStore/projects/types'
import { axiosInstance } from './axiosInstance'
import { END_POINT_PRODUCT } from './index'

/** One sheet's organizer edit. Leave a field out to keep it; folderId: null moves the sheet to the root. */
export interface SheetMetadataUpdate {
  id: string
  pageType?: string
  pdfPageNumber?: string
  starred?: boolean
  folderId?: string | null
}

// Only the fields sent change, on the saved page, so a stale copy can't overwrite takeoff (unlike PUT /drawing-page).
export const putSheetMetadata = (projectId: string, updates: SheetMetadataUpdate[]) => {
  return axiosInstance.request<drawingPage[]>({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/drawing-pages/${projectId}/metadata`,
    data: updates,
  })
}
